import React, { Component } from 'react'
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Button
} from 'reactstrap'
import {Link} from 'react-router-dom'

class Home extends Component {
  render() {
    let cBody = this.props.userProfiles.length === 1 ?
                <div className="px-md-5 py-3">
                  <p>Tipp: Ergänzen Sie Ihre Profilseite mit Bildern, Kundenstories und Termine, um mehr Besucher zu gewinnen.</p>
                  <Link to={`/profiles/${this.props.userProfiles[0].id}`}><Button tag="span" color="primary" className="col-md-5 col-sm-6">Zur Profilseite</Button></Link>
                </div>
                :
                <div className="px-md-5 py-3">
                  <p>Tipp: Ergänzen Sie Ihre Profilseiten mit Bildern, Kundenstories und Termine, um mehr Besucher zu gewinnen.</p>
                  <Link to={`/profiles`}><Button tag="span" color="primary" className="col-md-5 col-sm-6">Zu den Profilseiten</Button></Link>
                </div>

    return (
      <div className="animated fadeIn">
        <Row className="justify-content-center">
          <Col>
            <Card>
              <CardBody className="text-center">
                <h1>Herzlich Willkommen, {this.props.userInfo.first_name} {this.props.userInfo.last_name}</h1>
                {cBody}
                <div className="px-md-5">
                  <Link to={`/termine`}><Button tag="span" outline color="primary" className="col-md-5 col-sm-6">Termin hinzufügen</Button></Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/views/Home/Home.js